import DefaultCarousel from './DefaultCarousel';

export default DefaultCarousel;
